import { Component, OnInit, TemplateRef, ViewChild, ElementRef  } from '@angular/core';
import { Expediente } from 'app/models/expedientes/expediente';
import { ExpedienteService } from 'app/services/expediente.service';
import { ConvocatoriaService } from 'app/services/convocatoria.service';
import { Router, ActivatedRoute } from '@angular/router';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import { Observable, ReplaySubject } from 'rxjs';




@Component({
  selector: 'app-universidad',
  templateUrl: './universidad.component.html',
  styleUrls: ['./universidad.component.scss']
})
export class UniversidadComponent implements OnInit {
  loading: boolean;
  idcentro: string;
  idconvocatoria: number;
  expediente: Expediente;
  rol: any;
  modalRef: BsModalRef;
  base64Output: string;
  loadingvista: boolean;
  strURL: string;
  documentLoaded: boolean;
  typeValid: boolean;
  sizeValid: boolean;
  loadingsubmit: boolean;
  formsubmitted: boolean;
  autoinformeCompleto: boolean;
  AutoinformeForm: FormGroup;
  public radioGroupForm: FormGroup

  constructor(private route: ActivatedRoute,private fb: FormBuilder,
    private router: Router,
    private expedienteService: ExpedienteService,
    private convocatoriaService: ConvocatoriaService,
    private modalService: BsModalService) {

  this.loading = true;
  this.loadingvista = false;
  this.documentLoaded=false;

  this.AutoinformeForm = this.fb.group({
    'URL_USUARIO': new FormControl(''),
    'URL_PASSWORD': new FormControl(''),
    'URL': new FormControl(''),
    'MODIFICACIONES': new FormControl(''),
    'DOCUMENTO':new FormControl(''),
  });




}

  ngOnInit() {
    this.idcentro = String(this.route.snapshot.params['idcentro']);
    this.idconvocatoria = Number(this.route.snapshot.params['idconvocatoria']);
    if (this.idcentro && this.idconvocatoria ) { this.loadExpediente(this.idconvocatoria , this.idcentro); }
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.rol = currentUser.rol;
  }


  private loadExpediente(idconvocatoria, idcentro) {
    this.expedienteService.get(idconvocatoria, idcentro).subscribe(
      data => {this.expediente = data; this.loading = false; },
      error => {if (error.status = 401) {alert('Error de conexión con datos'); }}
    );
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, {class: 'modal-sm'});

  }

  decline(): void {
    this.modalRef.hide();
  }




  onFileSelected(event) {
    this.loadingvista = true;
    const file = event.target.files[0];
    console.log(file.type.indexOf("pdf"));
    this.typeValid=(file.type.indexOf("pdf")!=-1);
    this.sizeValid=(file.size<10000000);
    this.documentLoaded=true;
    if(this.typeValid && this.sizeValid)
    {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
        this.AutoinformeForm.get("DOCUMENTO").setValue(reader.result);
    };
    const DOCAUTOINFORME = new Blob([file], {type: 'application/pdf'});
    this.strURL = URL.createObjectURL(DOCAUTOINFORME);
  }
  else{
  this.strURL="";
  }
  this.loadingvista = false;
}



uploadExpediente(template,templateFail) {
  this.modalRef.hide();
  this.loadingsubmit=true;
  const accion = '1';
  this.expedienteService.put(this.idconvocatoria, this.idcentro, accion, this.AutoinformeForm.value ).subscribe(
    // tslint:disable-next-line:max-line-length
    data => { this.autoinformeCompleto=true; this.loadingsubmit = false;this.openModal(template); },
    error => {if (error.status == 401 || error.status == 413) {this.autoinformeCompleto=false; this.loadingsubmit = false; this.openModal(templateFail);  }}
  );
}



verAutoinforme() {
  this.expedienteService.getDOCAUTOINFORME(this.idconvocatoria, this.idcentro)
  .subscribe( data => {

    var binaryImg = atob(data);
    var length = binaryImg.length;
    var ab = new ArrayBuffer(length);
    var ua = new Uint8Array(ab);
    for (var i = 0; i < length; i++) {
        ua[i] = binaryImg.charCodeAt(i);
    }

    const DOCAYUDA = new Blob([ua], {type: 'application/pdf'});
    const strURL = URL.createObjectURL(DOCAYUDA);
    window.open(strURL);
    },
    error => {if (error.status = 401) {alert(error); }}
  );
}


}



// WEBPACK FOOTER //
// /app/src/app/modules/expedientes/expediente/universidad/universidad.component.ts